export default class Event {
  constructor() {
    this.events = {};
  }

  on(event, cb) {
    if (Array.isArray(event)) {
      for (let i = 0, l = event.length; i < l; i += 1) {
        this.on(event[i], cb);
      }
    } else {
      (this.events[event] || (this.events[event] = [])).push(cb);
    }
    return this;
  }

  once(event, cb) {
    function on(...args) {
      this.off(event, cb);
      cb.apply(this, args);
    }
    on.fn = cb;
    this.on(event, on);
    return this;
  }

  off(event, cb) {
    if (!arguments.length) {
      this.events = Object.create(null);
      return this;
    }
    if (Array.isArray(event)) {
      for (let i = 0, l = event.length; i < l; i += 1) {
        this.off(event[i], cb);
      }
      return this;
    }
    if (!cb) {
      this.events[event] = null;
      return this;
    }
    if (cb) {
      const cbs = this.events[event];
      let i = cbs.length;
      // eslint-disable-next-line no-cond-assign
      while (i -= 1) {
        if (cb === cbs[i] || cb === cbs[i].fn) {
          cbs.splice(i, 1);
          break;
        }
      }
      return this;
    }
    return this;
  }

  emit(event, ...args) {
    const cbs = this.events[event];
    if (cbs) {
      for (let i = 0, l = cbs.length; i < l; i += 1) {
        cbs[i].apply(this, args);
      }
    }
  }
}
